import incidentService from "../services/incident.service";

const incidents = {
    namespaced: true,
    state: {},
    actions: {
        //CREATE
        create(_, formData) {
            return incidentService.create(formData);
        },

        pushDocumentsToOldAccountModel(_, params) {
            return incidentService.pushDocumentsToOldAccountModel(params.patientId, params.oldAccountId);
        },

        addNote(_, params) {
            return incidentService.addNote(params.incidentId, params.text);
        },

        //READ
        get(_, params) {
            return incidentService.get(params.id, params.urlParameters, params.requestId);
        },

        getageing(_, params) {
            return incidentService.getAgeing(params.urlParameters);
        },
        getageingmanagement(_, params) {
            return incidentService.getageingmanagement(params.urlParameters);
        },
        getmanagementcaseadministratorwidget(_, params) {
            return incidentService.getmanagementcaseadministratorwidget(params.urlParameters);
        },
        getmanagementarearepresentativewidget(_, params) {
            return incidentService.getmanagementarearepresentativewidget(params.urlParameters);
        },                
        getIncidentPatient(_, identityId) {
            return incidentService.getIncidentPatient(identityId);
        },

        //UPDATE
        update(_, params) {
            return incidentService.update(params.id, params.formData);
        },

        //DELETE
        delete(_, id) {
            return incidentService.delete(id);
        },
    },
    getters: {},
    mutations: {},
};

export default incidents;
